<template>
  <v-tabs
    :vertical="$vuetify.breakpoint.width >= 960"
    :centered="$vuetify.breakpoint.width < 960"
  >
    <v-tab
      :class="
        $vuetify.breakpoint.width > 960 ? 'justify-start' : 'justify-center'
      "
    >
      <v-icon left> mdi-account </v-icon>
      <span class="hidden-sm-and-down">Dati personali</span>
    </v-tab>
    <v-tab
      :class="
        $vuetify.breakpoint.width > 960 ? 'justify-start' : 'justify-center'
      "
    >
      <v-icon left> mdi-account-group </v-icon>
      <span class="hidden-sm-and-down">Stato di famiglia</span>
    </v-tab>
    <v-tab
      :class="
        $vuetify.breakpoint.width > 960 ? 'justify-start' : 'justify-center'
      "
    >
      <v-icon left> mdi-file-document </v-icon>
      <span class="hidden-sm-and-down">Contratto</span>
    </v-tab>

    <v-tab-item>
      <v-card flat>
        <v-card-text class="hidden-md-and-up">
          <v-row no-gutters>
            <v-col cols="12" lg="6" offset-lg="3">
              <v-card outlined flat tile>
                <v-card-title>Codice Fiscale</v-card-title>
                <v-card-subtitle>{{ data.codiceFiscale }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Cognome</v-card-title>
                <v-card-subtitle>{{ data.cognome }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Nome</v-card-title>
                <v-card-subtitle>{{ data.nome }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Data di nascita</v-card-title>
                <v-card-subtitle>{{
                  data.dataNascita | dateFormat
                }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Sesso</v-card-title>
                <v-card-subtitle>{{ data.sesso }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Comune di nascita</v-card-title>
                <v-card-subtitle>{{ data.comuneNascita }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Provincia</v-card-title>
                <v-card-subtitle>{{ data.provinciaNascita }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Comune di residenza</v-card-title>
                <v-card-subtitle>{{ data.comuneResidenza }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Indirizzo</v-card-title>
                <v-card-subtitle>{{ data.indirizzo }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>E-mail</v-card-title>
                <v-card-subtitle>{{ data.email }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Telefono cellulare</v-card-title>
                <v-card-subtitle>{{ data.telefonoCellulare }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Telefono casa</v-card-title>
                <v-card-subtitle>{{ data.telefonoAbitazione }}</v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="hidden-sm-and-down">
          <v-row>
            <v-col col="12" lg="8" offset-lg="2" xl="6" offset-xl="2">
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Codice Fiscale</span>
                </v-col>
                <v-col cols="6">{{ data.codiceFiscale }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Cognome</span>
                </v-col>
                <v-col cols="6">{{ data.cognome }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Nome</span>
                </v-col>
                <v-col cols="6">{{ data.nome }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Data di nascita</span>
                </v-col>
                <v-col cols="6">{{ data.dataNascita | dateFormat }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Sesso</span>
                </v-col>
                <v-col cols="6">{{ data.sesso }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Comune di nascita</span>
                </v-col>
                <v-col cols="6">{{ data.comuneNascita }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Provincia</span>
                </v-col>
                <v-col cols="6">{{ data.provinciaNascita }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Comune di Residenza</span>
                </v-col>
                <v-col cols="6">{{ data.comuneResidenza }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Indirizzo</span>
                </v-col>
                <v-col cols="6">{{ data.indirizzo }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">E-mail</span>
                </v-col>
                <v-col cols="6">{{ data.email }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Telefono cellulare</span>
                </v-col>
                <v-col cols="6">{{ data.telefonoCellulare }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Telefono casa</span>
                </v-col>
                <v-col cols="6">{{ data.telefonoAbitazione }}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-tab-item>
    <v-tab-item>
      <v-card flat>
        <v-card-text class="hidden-md-and-up">
          <v-row no-gutters v-for="(f, index) in data.familiari" :key="index">
            <v-col cols="12" lg="6" offset-lg="3" class="mb-2">
              <v-card outlined flat tile>
                <v-card-title>Parentela</v-card-title>
                <v-card-subtitle>{{ f.parentela }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Codice fiscale</v-card-title>
                <v-card-subtitle>{{ f.codiceFiscale }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Cognome</v-card-title>
                <v-card-subtitle>{{ f.cognome }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Nome</v-card-title>
                <v-card-subtitle>{{ f.nome }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Data di nascita</v-card-title>
                <v-card-subtitle>{{
                  f.dataNascita | dateFormat
                }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Sesso</v-card-title>
                <v-card-subtitle>{{ f.sesso }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Comune di nascita</v-card-title>
                <v-card-subtitle>{{ f.comuneNascita }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Provincia</v-card-title>
                <v-card-subtitle>{{ f.provinciaNascita }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Stato civile</v-card-title>
                <v-card-subtitle>{{ f.statoCivile }}</v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="hidden-sm-and-down">
          <v-row v-for="(f, index) in data.familiari" :key="index" class="mt-2">
            <v-col col="12" lg="8" offset-lg="2" xl="6" offset-xl="2">
              <v-row class="bordered parentela mb-1">
                <v-col cols="12" class="text-center">
                  <span class="font-weight-bold text-h6">
                    {{ f.parentela }}
                  </span>
                </v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Codice fiscale</span>
                </v-col>
                <v-col cols="6">{{ f.codiceFiscale }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Cognome</span>
                </v-col>
                <v-col cols="6">{{ f.cognome }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Nome</span>
                </v-col>
                <v-col cols="6">{{ f.nome }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Data di nascita</span>
                </v-col>
                <v-col cols="6">{{ f.dataNascita | dateFormat }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Sesso</span>
                </v-col>
                <v-col cols="6">{{ f.sesso }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Comune di nascita</span>
                </v-col>
                <v-col cols="6">{{ f.comuneNascita }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Provincia</span>
                </v-col>
                <v-col cols="6">{{ f.provinciaNascita }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Stato civile</span>
                </v-col>
                <v-col cols="6">{{ f.statoCivile }}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-tab-item>
    <v-tab-item>
      <v-card flat>
        <v-card-text class="hidden-md-and-up">
          <v-row no-gutters>
            <v-col cols="12" lg="6" offset-lg="3" class="mb-2">
              <v-card outlined flat tile>
                <v-card-title>Data assunzione</v-card-title>
                <v-card-subtitle>{{
                  data.dataAssunzione | dateFormat
                }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>CCNL</v-card-title>
                <v-card-subtitle>{{ data.ccnl }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Livello</v-card-title>
                <v-card-subtitle>{{ data.livello }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Mansione</v-card-title>
                <v-card-subtitle>{{ data.mansione }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Categoria/attività</v-card-title>
                <v-card-subtitle>{{ data.categoria }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Tipo contratto/rapporto</v-card-title>
                <v-card-subtitle>{{ data.tipoContratto }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>Durata</v-card-title>
                <v-card-subtitle>{{ data.durata }}</v-card-subtitle>
              </v-card>
              <v-card outlined flat tile>
                <v-card-title>
                  <span class="hidden-xs-only">Bonifico stipendio - </span>
                  IBAN
                </v-card-title>
                <v-card-subtitle>{{ data.iban }}</v-card-subtitle>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-text class="hidden-sm-and-down">
          <v-row>
            <v-col col="12" lg="10" offset-lg="1" xl="6" offset-xl="2">
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Data assunzione</span>
                </v-col>
                <v-col cols="6">{{ data.dataAssunzione | dateFormat }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">CCNL</span>
                </v-col>
                <v-col cols="6">{{ data.ccnl }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Livello</span>
                </v-col>
                <v-col cols="6">{{ data.livello }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Mansione</span>
                </v-col>
                <v-col cols="6">{{ data.mansione }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Categoria/attività</span>
                </v-col>
                <v-col cols="6">{{ data.categoria }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Tipo contratto/rapporto</span>
                </v-col>
                <v-col cols="6">{{ data.tipoContratto }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black">Durata</span>
                </v-col>
                <v-col cols="6">{{ data.durata }}</v-col>
              </v-row>
              <v-row class="bordered mb-1">
                <v-col cols="6">
                  <span class="font-weight-black"
                    >Bonifico stipendio - IBAN</span
                  >
                </v-col>
                <v-col cols="6">{{ data.iban }}</v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
export default {
  name: "employee-profile",
  props: {
    fetchData: Function,
    reset: Function,
    data: Object,
  },
  mounted() {
    this.fetchData();
  },
  destroyed() {
    this.reset();
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
@import '../assets/css/variables.scss';
.bordered {
  border-width: 0px 0px 2px 0px;
  border-style: solid;
  border-color: $systemcolor;
}
.parentela {
  background-color: $systemcolor;
  color: #fff;
}
</style>